import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SharedDialogOptions } from 'src/app/ui/shared-dialog/shared-dialog.component';

export type CommissionDialogType = 'edit' | 'delete' | 'deleteAll' | 'enable' | 'disable'
export interface CommissionDialogData {
  dialogType: CommissionDialogType,
  deleteCount?: number;
}

@Component({
  selector: 'app-commission-comfirmation-dialog',
  templateUrl: './commission-comfirmation-dialog.component.html',
  styleUrls: ['./commission-comfirmation-dialog.component.scss'],
})
export class CommissionComfirmationDialogComponent implements OnInit {
  dialogTitle: string = '';
  dialogDescription: string = '';

  options: SharedDialogOptions = {
    confirmText: '',
    confirmButtonStyle: 'primary-btn',
    cancelText: '',
    cancelButtonStyle: 'secondary-btn',
    size: 'medium',
    hideHeader: true
  }

  constructor(
    private dialogRef: MatDialogRef<CommissionComfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CommissionDialogData,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    // Set cancel text translation
    this.translateService.get('common.cancel').subscribe((res: string) => {
      this.options.cancelText = res;
    });

    // Set dialog content and confirm button based on dialogType
    let titleKey = '';
    let descKey = '';
    let confirmKey = '';

    switch (this.data.dialogType) {
      case 'edit':
        titleKey = 'commission.dialog.update_title';
        descKey = 'commission.dialog.update_desc';
        confirmKey = 'commission.actions.apply_changes';
        this.options.confirmButtonStyle = 'primary-btn';
        break;
      case 'enable':
        titleKey = 'commission.dialog.enable_title';
        descKey = 'commission.dialog.enable_desc';
        confirmKey = 'commission.actions.enable';
        this.options.confirmButtonStyle = 'primary-btn';
        break;
      case 'disable':
        titleKey = 'commission.dialog.disable_title';
        descKey = 'commission.dialog.disable_desc';
        confirmKey = 'commission.actions.disable';
        this.options.confirmButtonStyle = 'danger-btn';
        break;
      case 'delete':
        titleKey = 'commission.dialog.delete_title';
        descKey = 'commission.dialog.delete_desc';
        confirmKey = 'common.delete';
        this.options.confirmButtonStyle = 'danger-btn';
        break;
      case 'deleteAll':
          titleKey = 'commission.dialog.delete_all_title';
          descKey = 'commission.dialog.delete_all_desc';
          confirmKey = 'common.delete';
          this.options.confirmButtonStyle = 'danger-btn';
          break;
      default:
        // fallback to edit
        titleKey = 'commission.dialog.update_title';
        descKey = 'commission.dialog.update_desc';
        confirmKey = 'commission.actions.apply_changes';
        this.options.confirmButtonStyle = 'primary-btn';
        break;
    }

    this.translateService.get([titleKey, descKey, confirmKey]).subscribe((translations: any) => {
      this.dialogTitle = translations[titleKey];
      this.dialogDescription = translations[descKey];
      this.options.confirmText = this.data.dialogType === "deleteAll" && this.data.deleteCount! > 1
        ? translations[confirmKey] + ' (' + this.data.deleteCount + ')'
        : translations[confirmKey];
    });
  }

  save() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close();
  }
}
